import React, { useState } from "react";
import AlertDismissible from "../../components/common/alertDismissible/AlertDismissible";
import { PageHeading } from "../../components/common/pageHeading/PageHeading";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import styles from "./customerDetails.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import {
  useDeleteCustomerMutation,
  useGetCustomerQuery,
} from "../../features/api/customers/customersApi";
import { SuccessDelete } from "../../components/common/successDelete/SuccessDelete";
import { Loader } from "../../components/common/loader/Loader";
import { useIsAdmin } from "../../customHooks/roleChecker/useIsAdmin";
import { useIsManager } from "../../customHooks/roleChecker/useIsManager";
import { useIsSuperAdmin } from "../../customHooks/roleChecker/useIsSuperAdmin";
import useIsMobile from "../../customHooks/useIsMobile";

export const CustomerDetails = () => {
  const isMobile = useIsMobile();
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isSuperAdmin = useIsSuperAdmin();
  const [showAlert, setShowAlert] = useState(false);
  const { customerId } = useParams();
  const navigate = useNavigate();
  const {
    data: customerDetail,
    isLoading,
    isError,
  } = useGetCustomerQuery(customerId);
  const [
    deleteCustomer,
    {
      isLoading: isDeleting,
      isSuccess: isSuccessOnDelete,
      isError: isErrOnDelete,
    },
  ] = useDeleteCustomerMutation();

  const handleDelete = () => {
    setShowAlert(true);
  };
  const handleConfirm = async (confirmed) => {
    setShowAlert(confirmed);
    if (confirmed) {
      await deleteCustomer(customerId).unwrap();
      setTimeout(() => {
        navigate("/customers");
      }, 3000);
    }
    return;
  };

  //Decide what to render -

  let content = null;

  if (isLoading || isDeleting) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Customer details"} />
        <Loader />
      </div>
    );
  }
  if (isSuccessOnDelete) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Customer details"} />
        <SuccessDelete />
      </div>
    );
  }
  if (isErrOnDelete || isError) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Customer details"} />
        <p>Server error</p>
      </div>
    );
  }

  if (customerDetail && !isSuccessOnDelete && !isDeleting) {
    content = (
      <div className="mb-5">
        <AlertDismissible
          title="Warning!"
          msg="Are you sure you want to proceed?"
          type="warning"
          showAlert={showAlert}
          onConfirm={handleConfirm}
        />
        <PageHeading title={"Customer details"} />
        <Container className={`${styles.productContainer} my-5`}>
          <Button
            variant="outline-light"
            onClick={() => navigate("/customers")}
            className={`${styles.btnProductList} m-4`}
          >
            <FontAwesomeIcon icon={faList} size="xl" />
          </Button>{" "}
          <h2 className={`${styles.customerName} shadow-sm`}>
            {customerDetail?.companyName}
          </h2>
          <hr />
          <Row>
            <Col lg={6} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Contact</Card.Header>
                <Card.Body>
                  <Card.Title className={styles.cardTitle}>
                    {customerDetail?.phone}
                  </Card.Title>
                  <Card.Subtitle className="mb-1 text-muted">
                    {customerDetail?.email}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Registration</Card.Header>
                <Card.Body>
                  <Card.Title className={styles.cardTitle}>
                    Siret : {customerDetail?.registrationNo}
                  </Card.Title>
                  <Card.Subtitle className="mb-1 text-muted">
                    {customerDetail?.lastName} {customerDetail?.firstName}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Billing address</Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-muted">
                    {customerDetail?.address}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Delivery address</Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-muted">
                    {customerDetail?.deliveryAddress}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {(isSuperAdmin || isAdmin || isManager) && (
            <Row className="my-2">
              <Col className="mt-1">
                <Card border="info">
                  <Card.Header>Action</Card.Header>
                  <Row className="p-2">
                    <Col lg={6} md={6} xs={12}>
                      <div
                        className={`d-flex ${
                          isMobile
                            ? "justify-content-center"
                            : "justify-content-end"
                        }`}
                      >
                        <Link
                          to={`/edit-customer/${customerDetail?.id}`}
                          className={` ${isMobile ? "mb-2 w-100" : ""}`} // Margin and full width for mobile
                        >
                          <Button
                            variant="warning"
                            className={`px-5 ${isMobile ? "w-100" : ""}`} // Full width only on mobile
                          >
                            Edit
                          </Button>
                        </Link>
                      </div>
                    </Col>
                    <Col lg={6} md={6} xs={12}>
                      <div
                        className={`d-flex ${
                          isMobile
                            ? "justify-content-center"
                            : "justify-content-start"
                        }`}
                      >
                        <Button
                          variant="danger"
                          className={`px-5 ${isMobile ? "w-100" : ""} ${
                            isMobile ? "mt-2" : ""
                          }`} // Full width and top margin on mobile
                          onClick={handleDelete}
                        >
                          Delete
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    );
  }
  return content;
};
